/**
 * The curated grade word banks, audited by `npm run audit:words`.
 *
 * Bundled as JSON imports rather than fetched, so the first level can start
 * without waiting on the network. ~2900 words, about 25 KB before gzip.
 */
import grade3 from './grade3.json';
import grade4 from './grade4.json';
import grade5 from './grade5.json';
import grade6 from './grade6.json';
import grade7 from './grade7.json';
import grade8 from './grade8.json';
import type { GradeBand } from '../../types';

export interface GradeWordFile {
  readonly grade: number;
  readonly words: readonly string[];
}

export const WORD_LISTS: Record<GradeBand, readonly string[]> = {
  3: grade3.words,
  4: grade4.words,
  5: grade5.words,
  6: grade6.words,
  7: grade7.words,
  8: grade8.words,
};

/** Total curated words, handy for dev logging. */
export function wordCount(): number {
  return Object.values(WORD_LISTS).reduce((sum, list) => sum + list.length, 0);
}
